import React from "react";
import PrimaryButton from "../../../stories/Components/Buttons/PrimaryButton";
import TertiaryButton from "../../../stories/Components/Buttons/TertiaryButton";

const ContainerEditButtons = ({
  disableButtons,
  onCancel,
  onSave,
  isSaving,
  noChangesMade,
  isValid,
  isLoading,
  resetSystemSettings,
  isPtoLocationInvalid,
}) => {
  return (
    !disableButtons && (
      <div className="flex flex-row gap-4 justify-end w-full">
        <TertiaryButton
          title="Cancel"
          className="mx-2"
          onClick={() => {
            onCancel();
            resetSystemSettings();
          }}
          disabled={isSaving || noChangesMade}
        />
        <PrimaryButton
          title="Save Changes"
          onClick={onSave}
          disabled={
            isLoading || !isValid || noChangesMade || isPtoLocationInvalid
          }
        />
      </div>
    )
  );
};

export default ContainerEditButtons;
